<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import SpaceCard from 'shared/components/SpaceCard.vue';
import ExperienceSearchCard from 'shared/components/ExperienceSearchCard.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import { CONTENT_TYPES } from '../constants';

const { content, contentAttributes, contentType } = useMessageContext();

const cards = computed(() => useSnakeCase(contentAttributes.value.items || []));

const isExperienceCards = computed(
  () => contentType.value === CONTENT_TYPES.EXPERIENCE_CARDS
);
</script>

<template>
  <BaseBubble class="p-3 overflow-hidden" data-bubble-name="space-cards">
    <div v-if="content" class="mb-3 text-sm text-n-slate-12">
      {{ content }}
    </div>
    <div class="flex items-stretch gap-4 overflow-x-auto pb-1">
      <div
        v-for="(card, index) in cards"
        :key="card.id || index"
        class="flex w-[280px] max-w-full shrink-0"
      >
        <ExperienceSearchCard v-if="isExperienceCards" :item="card" />
        <SpaceCard v-else :item="card" />
      </div>
    </div>
  </BaseBubble>
</template>
